import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-content-modal',
  templateUrl: './content-modal.component.html',
  styleUrls: ['./content-modal.component.scss'],
})
export class ContentModalComponent implements OnInit {
  @Input() contentTag: string;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
    console.log(this.contentTag);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
